import * as React from 'react'
import * as S from './styles'

export const Heading = ({ children, ...props }) => {
  return (
    <S.Heading {...props}>
      { children }
    </S.Heading>
  )
}